import { KTSVG } from "../../../_metronic/helpers";

const Modal = ({children, id, size, title}) => {

  return (
    <div className={`modal fade`} tabIndex={-1} id={id}>
      <div className={`modal-dialog ${size ? size : ''}`}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fs-3 text-gray-700">{title}</h5>
            <div
              className="btn btn-icon btn-sm btn-active-light-primary ms-2"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <KTSVG
                path="/media/icons/duotune/arrows/arr061.svg"
                className="svg-icon svg-icon-2x"
              />
            </div>
          </div>
          <div className="modal-body">
            { children }
          </div>
          {/* <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button type="button" className="btn btn-primary">
              Save changes
            </button>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default Modal

